/**
 * Application URLs
 */
export enum Urls {
    DISTRIBUTOR = 'distributor',
    AGENT = 'agent',
    UNIT = 'unit',
    PRODUCT = 'product',
};

/**
* Application routes
*/
export enum Routes {
    home = '/',
    login = '/login',
    recover = '/recover',
    code = '/code',
    distributors = '/distributors',
    auditors = '/auditors',
    auditeds = '/auditeds',
    assignment = '/assignment',
    alerts = '/alerts',
    links = '/links',
    products = '/products',
    agents = '/agents',
    agentsAdmin = '/adminAgents',
    audits = '/audits',
    users = '/users',
    agentsMe = '/agents/me',
    history = '/history',
    adminHistory = '/adminHistory',
    ehssHistory = '/historyweb',
    qaHistory = '/qahistory',
    goals = '/goals',
    units = '/unit',
    profile = '/profile',
    client = '/client',
    productionLines = '/productionlines',
    workstations = '/workstations',
    permissions = '/permissions',
    testesAPI = '/testes',
    workflow = '/workflow',
    taskflow = '/taskflow',
    dashboard = '/dashboard',
    export = '/export',
    ticketDetails = '/ticketdetailsqafs',
    ticketDetailsEhss = '/ticketdetailsehss',
    executionprocess = '/ticket',
    componentFormflow = '/componentFormflow',
    formflowProcess = '/formflowProcess',
    notifications = '/notifications',
    workflows = '/workflows',
    manager = '/manager',
    model3d = '/model3d',
    targets = '/targets',
    processManagement = '/processmanagement',
    liteProcesses = '/liteProcesses',
    process = '/process',
    liteReports = '/liteReports',
    scheduler = '/scheduler',
    my_processes = '/my-processes'
};